import { ProblemProgress as ProblemProgressType } from '@yandex-int/k-common/typings';
import b from 'b_';
import { WarningFilled } from 'education-icons';
import { Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import React from 'react';
import { connect } from 'react-redux';

import { STATS_THEME } from 'common.components/lesson-view.stats/typings';
import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';
import { getTeamIdFromPath } from 'utils/path';

import { EmptyStateContainer } from '../__empty-state/stats__empty-state.container';
import StatsProgress from '../__stats-progress/stats__stats-progress';
// @ts-ignore
import COLORS from '../constants.scss';
import * as selectors from '../selectors';

import './stats__problem-stats.scss';

interface StoreProps {
    assignedStudents: Array<number>;
    isProblemDifficult: boolean;
    problemStats: ProblemProgressType | null;
    problemViewsCount: number;
    shouldShowEmptyState: boolean;
    time: string;
    isTheory: boolean;
    isOpenAnswer: boolean;
    answeredProblemsCount: number;
}

interface Props extends StoreProps {}

export const ProblemStats = (props: Props) => {
    const {
        assignedStudents,
        isProblemDifficult,
        problemStats,
        problemViewsCount,
        shouldShowEmptyState,
        time,
        isTheory,
        isOpenAnswer,
        answeredProblemsCount,
    } = props;

    if (shouldShowEmptyState) {
        return <EmptyStateContainer />;
    }

    const renderStat = () => {
        if (isTheory) {
            const viewed = problemViewsCount;
            const notViewed = assignedStudents.length - problemViewsCount;

            return (
                <StatsProgress
                    stats={{ success: viewed, unknown: notViewed, fail: 0 }}
                    successTextId="lessonView.stats.problemViewed"
                    unknownTextId="lessonView.stats.problemNotViewed"
                />
            );
        }

        if (isOpenAnswer) {
            const success = answeredProblemsCount;
            const unknown = assignedStudents.length - success;

            return (
                <StatsProgress
                    stats={{ success, unknown, fail: 0 }}
                    successTextId="lessonView.stats.problemCompleted"
                    theme={STATS_THEME.BLUE}
                    unknownTextId="lessonView.stats.problemNotCompleted"
                />
            );
        }

        return (
            <StatsProgress
                failTextId="lessonView.stats.problemFailed"
                stats={problemStats}
                successTextId="lessonView.stats.problemSolved"
                unknownTextId="lessonView.stats.problemUnknown"
            />
        );
    };

    const shouldShowTime = !isOpenAnswer;

    return (
        <>
            {isProblemDifficult && (
                <div className={b('stats', 'item', { type: 'difficult-problem' })}>
                    <div className="stats__difficult-problem-header">
                        <WarningFilled className="stats__difficult-problem-header-icon" />
                        <Text id="lessonView.stats.difficultProblem" />
                    </div>
                    <Text
                        color={COLORS.lessonStatText}
                        id="lessonView.stats.difficultProblem.description"
                        size={Text.SIZE.S}
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                    />
                </div>
            )}
            <div className={b('stats', 'item', { type: 'problem-stats' })}>{renderStat()}</div>
            {shouldShowTime && (
                <div className={b('stats', 'item', { type: 'time' })}>
                    <Text size={Text.SIZE.XXL}>{time}</Text>
                    <Text
                        color={COLORS.lessonStatText}
                        id={isTheory ? 'lessonView.stats.problemTime.theory' : 'lessonView.stats.problemTime'}
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                    />
                </div>
            )}
        </>
    );
};

const mapStateToProps = (storeState: any): StoreProps => {
    const classId = getTeamIdFromPath();

    return {
        assignedStudents: selectors.getAssignedStudents(storeState, { classId }),
        isProblemDifficult: selectors.getIsProblemDifficult(storeState),
        problemStats: selectors.getProblemStats(storeState),
        problemViewsCount: selectors.getProblemViewsCount(storeState),
        shouldShowEmptyState: selectors.getAreProblemStatsEmpty(storeState, { classId }),
        time: selectors.getAverageProblemTime(storeState),
        isTheory: lessonViewSelectors.getIsTheoryProblemSelected(storeState),
        isOpenAnswer: lessonViewSelectors.getIsOpenAnswerProblemSelected(storeState),
        answeredProblemsCount: selectors.getAnsweredProblemsCount(storeState),
    };
};

export default connect(mapStateToProps)(ProblemStats);
